<script lang="ts">
  // HR Continuity view (Phase 4, spec 5.7) — "My actions": continuity_actions
  // this HR user owns. Description/due/status only — no OKR/person data.
  import { createQuery, useQueryClient } from '@tanstack/svelte-query';
  import { hrContinuityApi } from '$lib/api/hrContinuity';
  import { getErrorMessage } from '$lib/api/client';
  import { toast } from '$lib/state/toast.svelte';

  const queryClient = useQueryClient();
  const query = createQuery(() => ({ queryKey: ['hr-continuity-my-actions'], queryFn: () => hrContinuityApi.myActions() }));

  function refresh() {
    queryClient.invalidateQueries({ queryKey: ['hr-continuity-my-actions'] });
  }

  async function toggleDone(id: number, status: 'open' | 'done') {
    try {
      await hrContinuityApi.updateMyAction(id, status === 'done' ? 'open' : 'done');
      refresh();
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  }
</script>

<div class="tym-page">
  <p class="tym-section-sub mb-4">Follow-up items assigned to you.</p>

  {#if query.isLoading}
    <div class="tym-loading-state">Loading...</div>
  {:else if query.isError}
    <div class="tym-error-state">Could not load your actions.</div>
  {:else if query.data}
    <div class="space-y-1.5">
      {#each query.data as a (a.id)}
        <div class="flex items-center justify-between gap-2 rounded-lg border border-toyama-cloudy-gray bg-surface px-3 py-2">
          <div>
            <p class="text-[13px] {a.status === 'done' ? 'text-dark-gray line-through' : 'text-navy'}">{a.description}</p>
            {#if a.due_date}<p class="text-[11px] text-dark-gray">Due {a.due_date}</p>{/if}
          </div>
          <button type="button" class="btn-secondary !px-2 shrink-0" onclick={() => toggleDone(a.id, a.status)}>
            {a.status === 'done' ? 'Reopen' : 'Done'}
          </button>
        </div>
      {:else}
        <p class="text-[13px] text-dark-gray">Nothing assigned to you.</p>
      {/each}
    </div>
  {/if}
</div>
